import { derived } from 'svelte/store';
import type { DashboardAccessSummary } from '$lib/api/modules-access';
import { loadModulesAccess, modulesAccess, modulesAccessState, resetModulesAccess } from './modulesAccess';

export type { DashboardAccessSummary } from '$lib/api/modules-access';

export const dashboardAccess = derived(modulesAccess, ($modulesAccess) => $modulesAccess.dashboard);
export const isLoadingDashboardAccess = derived(modulesAccessState, ($state) => $state.status === 'refreshing');

export async function loadDashboardAccess(force = false): Promise<void> {
  await loadModulesAccess(force);
}

export function resetDashboardAccess(): void {
  resetModulesAccess();
}
